export default "__VITE_ASSET__CCKBISXm__"